export default "__VITE_ASSET__AjOwtMF4__"